import {Component, Input} from '@angular/core';
import {roles, rolesLabelMap} from "../../../../../constants/common.constants";

@Component({
  selector: 'app-user-details-shimmer-loader',
  templateUrl: './user-details-shimmer-loader.component.html',
  styleUrls: ['./user-details-shimmer-loader.component.css']
})
export class UserDetailsShimmerLoaderComponent {

  @Input() userDetails;

  protected readonly roles = roles;
  protected readonly rolesLabelMap = rolesLabelMap;
}
